var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[_c('div',[_c('froala',{attrs:{"id":"edit","tag":'textarea',"config":_vm.config},on:{"focus":function($event){}},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }